import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { useSEO } from '../../hooks/useSEO';
import { SITE_URL } from '../../utils/siteConfig';

const posts = [
  {
    slug: 'lage-moq-inkopen-china',
    title: 'Lage MOQ inkopen uit China: kleine hoeveelheden bestellen met private label',
    excerpt: 'Denk je dat je duizenden stuks moet bestellen om uit China in te kopen? Dat hoeft niet. DUC heeft een groot netwerk en regelt óók kleine hoeveelheden met private label — vanaf 50 stuks.',
    category: 'Inkopen & Sourcing',
    icon: 'ri-stack-line',
    readTime: '10 min',
    inkoopprijs: 'Fabrieksprijs',
    verkoopprijs: '30–80% besparing',
    image: 'https://public.readdy.ai/ai/img_res/8dcde498bb96cc1c04e0b8a75678a63b.jpg batch product samples arranged neatly on a clean white table, variety of consumer goods in small quantities including packaging boxes bottles and accessories, minimal clean studio photography with warm neutral background, professional product sourcing photography showing small order samples organized tidily, soft shadows warm ivory tones, high quality commercial photography&width=600&height=400&seq=blog-lage-moq-card-001&orientation=landscape',
    keywords: ['lage MOQ China', 'minimale bestelhoeveelheid China', 'kleine hoeveelheden inkopen China', 'low MOQ leverancier', 'private label lage MOQ'],
  },
  {
    slug: 'private-label-producten-china',
    title: 'Private label producten laten maken in China: jouw merk, fabrieksprijs',
    excerpt: 'Zelf een merk bouwen voor fabrieksprijzen — dat is private label. Van skincare tot sportartikelen, DUC regelt het complete traject van productie tot DDP levering aan jouw deur.',
    category: 'Private Label & Branding',
    icon: 'ri-award-line',
    readTime: '11 min',
    inkoopprijs: 'Fabrieksprijs',
    verkoopprijs: '3× – 8× markup',
    image: 'https://readdy.ai/api/search-image?query=private label product packaging collection professionally arranged, custom branded boxes bottles and bags with logos in a clean studio setting, multiple branded lifestyle products with elegant custom branding, warm neutral tones premium packaging design cosmetics skincare homeware, high end commercial product photography with soft lighting and white background&width=600&height=400&seq=blog-private-label-card-001&orientation=landscape',
    keywords: ['private label China', 'eigen merk producten China', 'white label importeren', 'private label sourcing agent'],
  },
  {
    slug: 'geborduurde-tshirts-inkopen-china',
    title: 'Geborduurde T-shirts inkopen uit China: tot 300% marge',
    excerpt: 'Kwalitatieve 250g katoenen T-shirts met borduurwerk — ingekocht voor €6-9, verkocht voor €25-35. Hoe jij dit product slim inkoopt voor jouw merk of webshop.',
    category: 'Mode & Merchandise',
    icon: 'ri-t-shirt-2-line',
    readTime: '8 min',
    inkoopprijs: '€6 – €9',
    verkoopprijs: '€25 – €35',
    image: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/005aff3f-6650-4614-a607-26ddd6659aa1_Geborduurde-T-shirts.png?v=9229927384bb88bb0001a1c9cb51e92e',
    keywords: ['private label kleding', 'merchandise inkopen China', 'T-shirts laten maken China'],
  },
  {
    slug: 'luxe-wandlampen-inkopen-china',
    title: 'Luxe wandlampen inkopen uit China: €40 inkoopprijs, €250 verkoopprijs',
    excerpt: 'Wandlampen zijn een van de meest winstgevende home decor producten. Leer hoe je ze direct bij Chinese fabrikanten inkoopt met marges tot 500%.',
    category: 'Home Decor',
    icon: 'ri-lightbulb-line',
    readTime: '9 min',
    inkoopprijs: '€10 – €40',
    verkoopprijs: '€50 – €250',
    image: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/194b5713-511a-4f9c-819d-4b1206a0ed17_Luxe-Wandlampen.png?v=b0f8a4fe0795f40af5cd79d75cb073be',
    keywords: ['wandlampen inkopen China', 'home decor groothandel', 'verlichting importeren'],
  },
  {
    slug: 'ev-laadkabels-inkopen-china',
    title: 'EV laadkabels (22kW) inkopen uit China: de groeimarkt van 2025',
    excerpt: 'EV laadkabels zijn hot. Inkoop voor €50-65 per stuk, verkoop voor €130-300. Een product met explosieve vraag en structurele B2B-kansen.',
    category: 'EV & Technologie',
    icon: 'ri-charging-pile-2-line',
    readTime: '9 min',
    inkoopprijs: '€50 – €65',
    verkoopprijs: '€130 – €300',
    image: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/fdeb3f8c-435c-4db8-a39b-0f8c9f176577_Laadkabels.png?v=0cb2bc1693bcfc1d81a3f7bf37303786',
    keywords: ['EV laadkabels inkopen', 'laadkabels China import', 'elektrisch rijden groothandel'],
  },
  {
    slug: 'bedrukte-paper-bags-inkopen-china',
    title: 'Luxe bedrukte paper bags inkopen uit China: 100–300% markup',
    excerpt: 'Bedrukte draagassen zijn een must-have voor winkels, horeca en events. Voor €0,50 ingekocht, voor €1,50-3,00 verkocht — en iedereen wil ze.',
    category: 'Verpakkingen',
    icon: 'ri-shopping-bag-line',
    readTime: '7 min',
    inkoopprijs: '€0,50 – €0,65',
    verkoopprijs: '€1,50 – €3,00',
    image: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/b9db8b99-c298-42fb-928a-99e6a64c3a2c_Paper-Bags.png?v=54b0a3d33ab5fd72c776f59deb54201d',
    keywords: ['bedrukte tassen inkopen China', 'papieren draagtassen groothandel', 'custom bags importeren'],
  },
  {
    slug: 'e-choppers-inkopen-china',
    title: 'E-choppers inkopen uit China: tot €3.000 winst per stuk',
    excerpt: 'E-choppers zijn de meest winstgevende rijdende producten van dit moment. All-in inkoop ±€1.500, verkoop €4.000-5.000. Een product met enorme marges en een groeiende markt.',
    category: 'E-mobiliteit',
    icon: 'ri-motorbike-line',
    readTime: '10 min',
    inkoopprijs: '±€1.500 all-in',
    verkoopprijs: '€4.000 – €5.000',
    image: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/1013c2d2-8f5b-40ee-af7a-1753ee825f7e_E-Choppers.png?v=a4bbf1f383eadc55d34d522c1e1974da',
    keywords: ['e-chopper inkopen China', 'elektrische chopper importeren', 'e-bike groothandel China'],
  },
  {
    slug: 'bedrukte-tissues-horeca-inkopen-china',
    title: 'Bedrukte tissues voor horeca inkopen uit China: slim en schaalbaar',
    excerpt: 'Elke horecazaak gebruikt tissues. Met uw eigen logo erop wordt een alledaags product een marketingtool. Inkopen uit China is de slimste keuze.',
    category: 'Horeca & Promotie',
    icon: 'ri-newspaper-line',
    readTime: '7 min',
    inkoopprijs: 'Laag (bulk)',
    verkoopprijs: 'Hoge marge',
    image: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/8c9334e0-c3ad-4c98-b75e-713698abf864_Goedkoopste-Tissues-met-logo.png?v=32efe83e596e204d5b12b6d6199fd5c4',
    keywords: ['bedrukte tissues horeca', 'servetjes met logo inkopen', 'tissues China importeren'],
  },
];

export default function BlogPage() {
  useSEO({
    title: 'Winning Products Blog | Private Label & Goedkoop Inkopen uit China | DUC',
    description: 'Ontdek winstgevende producten en private label mogelijkheden om in te kopen uit China. Met inkoopprijzen, verkoopprijzen en margeberekeningen. Van private label tot e-choppers — alles voor slimme ondernemers.',
    keywords: 'winning products China, private label China, producten inkopen China blog, marges import China, goedkoop inkopen producten, product ideeën China, eigen merk China, lage MOQ China, minimale bestelhoeveelheid China inkopen',
    canonical: `${SITE_URL}/blog`,
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
          { '@type': 'ListItem', position: 2, name: 'Blog', item: `${SITE_URL}/blog` },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Blog',
        '@id': `${SITE_URL}/blog#blog`,
        name: 'DUC Winning Products Blog — Inkopen uit China',
        description: 'Concrete analyses van winstgevende producten om in te kopen uit China. Inclusief inkoopprijzen, verkoopprijzen en hoe DUC het voor u regelt.',
        url: `${SITE_URL}/blog`,
        inLanguage: 'nl-NL',
        publisher: {
          '@type': 'Organization',
          name: 'Direct Uit China (DUC)',
          url: SITE_URL,
        },
        blogPost: posts.map((p) => ({
          '@type': 'BlogPosting',
          headline: p.title,
          description: p.excerpt,
          url: `${SITE_URL}/blog/${p.slug}`,
          image: p.image,
          keywords: p.keywords.join(', '),
          articleSection: p.category,
          inLanguage: 'nl-NL',
          datePublished: '2026-03-26',
          dateModified: '2026-03-26',
          author: { '@type': 'Organization', name: 'Direct Uit China (DUC)', url: SITE_URL },
          publisher: { '@type': 'Organization', name: 'Direct Uit China (DUC)', url: SITE_URL },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: 'Winning Products — Inkopen uit China',
        description: 'Overzicht van winstgevende producten om in te kopen uit China via DUC',
        url: `${SITE_URL}/blog`,
        numberOfItems: posts.length,
        itemListElement: posts.map((p, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: p.title,
          url: `${SITE_URL}/blog/${p.slug}`,
          description: p.excerpt,
        })),
      },
    ],
  });

  const heroRef = useRef<HTMLDivElement>(null);
  const heroInView = useInView(heroRef, { once: true });
  const gridRef = useRef<HTMLDivElement>(null);
  const gridInView = useInView(gridRef, { once: true, margin: '-60px' });

  return (
    <main className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section ref={heroRef} className="bg-[#0A1628] pt-[100px] sm:pt-[116px] lg:pt-[136px] pb-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 w-full">
          <motion.span initial={{ opacity: 0, y: 12 }} animate={heroInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.4 }} className="inline-flex items-center gap-2 border border-[#3B9EE8]/40 bg-[#3B9EE8]/10 rounded-full px-4 py-1.5 text-[#3B9EE8] text-sm font-600 mb-6">
            <i className="ri-article-line" />
            Winning Products Blog
          </motion.span>
          <motion.h1 initial={{ opacity: 0, y: 18 }} animate={heroInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.1 }} className="font-heading font-800 text-white text-3xl md:text-4xl lg:text-5xl leading-tight mb-5">
            Inkopen uit China:<br />
            <span className="text-[#3B9EE8]">Winning products met hoge marge</span>
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 14 }} animate={heroInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.2 }} className="text-white/60 text-base md:text-lg leading-relaxed max-w-2xl">
            Concrete SEO-analyses van de meest winstgevende producten om in te kopen uit China. Met inkoopprijzen, verkoopprijzen en margeberekeningen — zodat jij als ondernemer een geïnformeerde beslissing maakt.
          </motion.p>
        </div>
      </section>

      {/* Posts grid */}
      <section ref={gridRef} className="py-16 bg-[#F7F8FA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post, i) => (
              <motion.article
                key={post.slug}
                initial={{ opacity: 0, y: 24 }}
                animate={gridInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-white rounded-2xl border border-[#0A1628]/6 overflow-hidden hover:border-[#3B9EE8]/35 transition-all duration-200 group"
              >
                <Link to={`/blog/${post.slug}`} className="block cursor-pointer">
                  <div className="w-full h-48 overflow-hidden relative">
                    <img
                      src={post.image}
                      alt={`${post.title} — inkopen uit China via DUC`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="inline-flex items-center gap-1.5 bg-white/90 rounded-full px-3 py-1 text-[#0A1628] text-xs font-600">
                        <i className={`${post.icon} text-[#3B9EE8]`} />
                        {post.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-4 mb-3">
                      <span className="text-white/0 hidden">{post.keywords.join(', ')}</span>
                      <span className="text-[#0A1628]/45 text-xs flex items-center gap-1.5 whitespace-nowrap">
                        <i className="ri-time-line text-xs" />
                        {post.readTime}
                      </span>
                    </div>
                    <h2 className="font-heading font-700 text-[#0A1628] text-base leading-snug mb-3 group-hover:text-[#3B9EE8] transition-colors">
                      {post.title}
                    </h2>
                    <p className="text-[#0A1628]/55 text-sm leading-relaxed mb-5 line-clamp-3">{post.excerpt}</p>
                    <div className="flex flex-wrap gap-3 pt-4 border-t border-[#0A1628]/6">
                      <div className="flex-1 min-w-0">
                        <div className="text-[#0A1628]/40 text-xs mb-0.5">Inkoop China</div>
                        <div className="font-heading font-700 text-[#0A1628] text-sm whitespace-nowrap">{post.inkoopprijs}</div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="text-[#0A1628]/40 text-xs mb-0.5">Verkoop NL</div>
                        <div className="font-heading font-700 text-[#3B9EE8] text-sm whitespace-nowrap">{post.verkoopprijs}</div>
                      </div>
                      <div className="flex items-end">
                        <span className="inline-flex items-center gap-1 text-[#3B9EE8] text-xs font-600 whitespace-nowrap group-hover:gap-2 transition-all">
                          Lees meer <i className="ri-arrow-right-line" />
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#0A1628]">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="font-heading font-800 text-white text-2xl md:text-3xl mb-4">
            Klaar om te starten met <span className="text-[#3B9EE8]">goedkoper inkopen?</span>
          </h2>
          <p className="text-white/55 text-base mb-8 leading-relaxed">
            DUC regelt het hele traject — van leverancier selectie tot DDP levering. Vraag een gratis prijsindicatie aan en ontdek hoeveel jij kunt besparen.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact" className="inline-flex items-center gap-2 bg-[#3B9EE8] hover:bg-[#2D85C5] text-white px-7 py-3.5 rounded-lg font-700 text-sm transition-all cursor-pointer whitespace-nowrap">
              Vraag gratis offerte aan
              <i className="ri-arrow-right-line" />
            </Link>
            <a href="https://wa.me/31624359162?text=Hi%2C%20ik%20heb%20een%20blog%20gelezen%20en%20wil%20graag%20een%20offerte." target="_blank" rel="nofollow noreferrer" className="inline-flex items-center gap-2 border border-white/25 hover:border-[#3B9EE8]/60 text-white hover:text-[#3B9EE8] px-6 py-3.5 rounded-lg font-600 text-sm transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-line text-base" />
              WhatsApp DUC
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
